// import axios from "../../utils/request";
import axios from "../../utils/request";
import {
  sessionKey
} from "../../utils/index"
try {
  JSON.parse(sessionStorage.getItem(sessionKey))
} catch (e) {
  sessionStorage.removeItem(sessionKey)
}
try {
  JSON.parse(sessionStorage.getItem('largeConfig'))
} catch (e) {
  sessionStorage.removeItem('largeConfig')
}

const state = {
  profile: JSON.parse(sessionStorage.getItem(sessionKey)),
  largeConfig: JSON.parse(sessionStorage.getItem('largeConfig')) || {},
  channelAccout: sessionStorage.getItem('channelAccout') || ""
}

const mutations = {
  SET_PROFILE(state, profile) {
    state.profile = profile;
    sessionStorage.setItem(sessionKey, JSON.stringify(profile))
  },
  SET_LARGE_CONFIG(state, data) {
    state.largeConfig = data;
    sessionStorage.setItem('largeConfig', JSON.stringify(data))
  },
  SET_CHANNEL_ACCOUT(state, data) {
    state.channelAccout = data;
    sessionStorage.setItem('channelAccout', data)
  }
}

const actions = {
  getProfile({
    commit
  }) {
    return new Promise(reslove => {
      axios.get('https://mcapi.mdfitnesscao.com/mechanismService/mechanism/profile').then(resp => {
        commit('SET_PROFILE', resp.data.profile);
        reslove()
      })
    })
  },
  getLargeConfig({
    commit
  }) {
    return new Promise(reslove => {
      // axios.get('https://api.mdfitnesscao.com/statisticsService/mechanism/config', {
      //   params: {
      //     visibleErrorDialog: false
      //   }
      // }).then(resp => {
      //   commit('SET_LARGE_CONFIG', resp.data)
      //   reslove()
      // })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
